<script>

    import { toast } from 'bulma-toast'
    import { userStore, chargesStore, modalStore, notifyStore } from '../stores'

    import ChargesService from '../$services/charges.service'

    import Subtitle from '../$components/subtitle.svelte'
    import Form from '../$components/form.svelte'
    import InputText from '../$components/input.text.svelte'
    import InputNumber from '../$components/input.number.svelte'
    import Select from '../$components/select.svelte'

    import Button from '../$components/button.svelte'

    export let label = false
    export let shipmentId = null
    export let userId = null

    let data = {
        shipmentId,
        userId
    }

    const categories = {
        charge: [
            {value: 'overweight', text: 'Sobrepeso'},
            {value: 'manual_guide', text: 'Guía manual'},
            {value: 'extended_zone', text: 'Zona extendida'},
            {value: 'other', text: 'Otro'},
        ],
        refund: [
            {value: 'canceled_guide', text: 'Guía cancelada'},
            {value: 'balance_credit', text: 'Abono de saldo'},
            {value: 'promotion', text: 'Promoción'},
            {value: 'other', text: 'Otro'},
        ]
    }

    let loading = false

    $: overweight = data.category === 'overweight'

    function selectType() {
        data.category = ''
    }

    async function createCharge() {

        data.userId = userId || $userStore._id
        data.shipmentId = shipmentId

        if(overweight) {
            delete data.concept
            delete data.details
        } else {
            delete data.guide
            delete data.overweight
        }

        loading = true
        const resp = await ChargesService.createCharge(data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        chargesStore.append(resp.data)

        toast({message: 'Cargo creado', type: 'is-success'})
        notifyStore.set('wallet_updated')
        modalStore.close()
    }

</script>

{#if label}
    <Subtitle text="Crear cargo" />
{/if}

<Form on:submit={ createCharge } { loading } >

    <div class="columns">
        <div class="column">
            <Select bind:value={ data.type } 
                on:select={ selectType }
                label="Tipo"
                options={[
                    {value: 'charge', text: 'Cargo'},
                    {value: 'refund', text: 'Reembolso'},
                ]}
            />
        </div>
        <div class="column">
            <Select bind:value={ data.category } 
                label="Categoría"
                options={ categories[data.type] || [] }
            />
        </div>
    </div>

    {#if overweight}
        <div class="columns">
            {#if !shipmentId}
                <div class="column">
                    <InputText bind:value={ data.guide } label="Número de guía" placeholder="Número de guía" />
                </div>
            {/if}
            <div class="column">
                <InputNumber bind:value={ data.overweight } label="Peso excedido (kg)" placeholder="Peso excedido (kg)" min="0.01" />
            </div>
        </div>
    {/if}

    <div class="columns">
        {#if !overweight}
            <div class="column">
                <InputText bind:value={ data.concept } label="Concepto" placeholder="Concepto" />
            </div>
        {/if}
        <div class="column">
            <InputNumber bind:value={ data.amount } label="Monto" placeholder="Monto" />
        </div>
    </div>

    {#if !overweight}
        <div class="columns">
            <div class="column">
                <InputText bind:value={ data.details } label="Detalles" placeholder="Detalles" />
            </div>
        </div>
    {/if}

    <div class="items-end">
        <div class="buttons">
            <Button on:click={modalStore.close} text="Cancelar" icon="ban" color="light"/>
            <Button type="submit" text="Guardar" icon="save" color="primary" { loading } />
        </div>
    </div>

</Form>